import React, { useState } from 'react';
import {
  FDBodyText, FDClickableText, FDIcon, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { Collapse } from '@mui/material';
import { dataAttrs } from 'Helpers/Testing';
import { OutcomeActionLineItemLayout } from './components/OutcomeActionLineItemLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly)
  .done();

const MAX_VISIBLE_LINE_ITEMS = 3;

const OutcomeActionLayout = () => {
  const [expanded, setExpanded] = useState(false);
  const { resource } = useMetaLayoutContext();
  const alwaysVisibleLineItems = resource.attr('lineItems')?.resources().list().slice(0, MAX_VISIBLE_LINE_ITEMS) || [];
  const hiddenLineItems = resource.attr('lineItems')?.resources().list().slice(MAX_VISIBLE_LINE_ITEMS) || [];

  return (
    <div style={{ width: '100%', borderBottom: '1px solid #E0E0E0', marginBottom: '16px' }} {...dataAttrs('outcome-action')}>
      <FDStack direction={'column'} spacing={2} width={'100%'} paddingY={2}>
        <MetaControlField attr={'title'} />
        <FDStack direction={'column'} width={'100%'} spacing={2}>
          <FDStack direction={'column'} width={'100%'}>
            {alwaysVisibleLineItems.map((lineItem) => (
              <MetaResourceRenderer
                key={lineItem.id()}
                resource={lineItem}
                layout={OutcomeActionLineItemLayout}
                metaOverrideSet={metaOverrideSet}
              />
            ))}
            <Collapse in={expanded}>
              <FDStack direction={'column'} width={'100%'}>
                {hiddenLineItems.map((lineItem) => (
                  <MetaResourceRenderer
                    key={lineItem.id()}
                    resource={lineItem}
                    layout={OutcomeActionLineItemLayout}
                    metaOverrideSet={metaOverrideSet}
                  />
                ))}
              </FDStack>
            </Collapse>
          </FDStack>
          {hiddenLineItems.length > 0 && (
            <FDBodyText
              size={'lg'}
              value={
                <FDClickableText
                  onClick={() => setExpanded(!expanded)}
                  appearance={'standalone'}
                  label={expanded ? `Hide ${hiddenLineItems.length} actions` : `See ${hiddenLineItems.length} more actions`}
                />
              }
            />
          )}
        </FDStack>
        <FDStack direction={'row'} spacing={1}>
          <FDIcon icon={'info'} color={'primary'} />
          <MetaControlField attr={'reason'} />
        </FDStack>
      </FDStack>
    </div>
  );
};

export { OutcomeActionLayout };
